import React from 'react';
import { Layout, Row, Col, Input, Button } from 'antd';
import appleImage from '../../assets/images/appstore.png';
import goolgeImage from '../../assets/images/googleplay.png';
import './Footer.css' 
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

const { Footer } = Layout;

const CustomFooter = () => {
  const navigate = useNavigate();

  return (
    <Footer style={{ background: '#1D2939', color: '#FFFFFF',alignItems:'center', justifyContent:'center',display:'flex'}}>
      <Row style={{alignItems:'center',justifyContent:'space-around'}}>
        <Col style={{width:'15%',alignSelf:'baseline'}}>
          <h3 onClick={()=>{navigate('/under-construction')}} style={{ color: '#FFFFFF', fontSize:'14px',fontWeight:600}}>{t("FOOTER_pass_and_card")}</h3>
          <ul style={{ listStyleType: 'none', padding: 0,lineHeight:1.5 }}>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_USING_COOLPASS")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_how_you_save")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF' , fontSize:14,fontWeight:600}}>{t("FOOTER_get_your_pass")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF',  fontSize:14,fontWeight:600}}>{t("FOOTER_sales_points")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_reviews")}</a></li>
          </ul>
        </Col>
        <Col style={{width:'12%',alignSelf:'baseline'}}>
          <h3 onClick={()=>{navigate('/under-construction')}} style={{ color: '#FFFFFF' }}>{t("ATTRACTIONS_BOTTOM")}</h3>
          <ul style={{ listStyleType: 'none', padding: 0,lineHeight:1.5 }}>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_sightseeing_tours")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_areas")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_closures")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_whats_on")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_contact_us")}</a></li>
          </ul>
        </Col>
        <Col style={{width:'10%',alignSelf:'baseline'}}>
          <Button onClick={()=>{navigate('/under-construction')}} type="primary" style={{ backgroundColor: '#F15025', borderColor: '#F15025', fontSize:12,fontWeight:600,padding:'18px 40px' }}>{t("FAQ")}</Button>
          <ul style={{ listStyleType: 'none', padding: 0,lineHeight:1.5  }}>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_about_us")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600}}>{t("FOOTER_terms_and_conditions")}</a></li>
            <li><a href="#" style={{ color: '#FFFFFF', fontSize:14,fontWeight:600 }}>{t("FOOTER_cancellation_and_refund")}</a></li>
          </ul>
        </Col>
        <Col style={{width:'15%',alignSelf:'baseline'}}>
          <h3 style={{ color: '#FFFFFF' }}>{t("ESHOP_buttonText_manage_download")}</h3>
          <p>{t("FOOTER_prague_coolpass_app")}</p>
          <div className='download-image-container'>
            <img onClick={()=>{navigate('/under-construction')}} src={appleImage} />
            <img onClick={()=>{navigate('/under-construction')}} src={goolgeImage} />
          </div>

        </Col>
        <Col style={{width:'25%',alignSelf:'baseline'}}>
          <h3 style={{ color: '#FFFFFF', marginTop: '20px' }}>{t("NEWS_AND_UPDATES")}</h3>
          <Input.Search
            className="custom-search-button"
            placeholder={t("ENTER_EMAIL_PLACEHOLDER")}
            enterButton={
              <Button
                type="primary"
                size="large"
                onClick={() => navigate('/under-construction')}
              >
                {t("EMAIL_SUBSCRIBE").toUpperCase()}
              </Button>
            }
            size="large"
            style={{ maxWidth: '300px' }}
          />
          <p style={{fontWeight:'bold'}}>CoolPass 2020-2024</p>
          <p style={{fontWeight:'bold'}}>Prague Card 1992-2024</p>
          <p className="all-rights" >{t("ALL_RIGHTS_RESERVED_LABEL")}</p>

        </Col>
      </Row>
    </Footer>
  );
};

export default CustomFooter;
